export default "__VITE_ASSET__D1AaEoCj__"